module.exports = __webpack_public_path__ + "img/referrals-icon.5a1d4e00.svg";